import type { ApiErrorCommon } from '@imprivata-cloud/common';
import { ErrorCode, ErrorMessage, SESSION_ERROR_CODES } from './constants';

export interface ApiError extends ApiErrorCommon<ErrorCode> {
  httpStatus?: number;
}

// Base Class for application errors
export class AppError extends Error {
  static {
    AppError.prototype.name = 'AppError';
  }

  public details: ApiError;
  public params?: Record<string, unknown>;
  public code?: ErrorCode;

  constructor(e: ApiError, params?: Record<string, unknown>) {
    super(e?.message || e?.code || ErrorMessage.SYSTEM_ERROR);
    this.details = e instanceof AppError ? e.details : e;
    this.params = params || (e as AppError).params;
    this.code = e?.code || this.details.code || ErrorCode.UNKNOWN;
  }

  static fromMessage(msg: string, code?: ErrorCode) {
    return new AppError({ code: code || ErrorCode.UNKNOWN, message: msg });
  }
}

/**
 * NOTE: Base Error Types - All App Errors should be one of these 3
 */

// FatalError means full page error display, cannot authenticate

export class FatalError extends AppError {
  static {
    AppError.prototype.name = 'FatalError';
  }
}

export const isSessionError = (e: unknown): e is ApiError =>
  typeof e === 'object' &&
  e !== null &&
  'code' in e &&
  SESSION_ERROR_CODES.some(code => code === e.code);
